import React, { Suspense } from 'react'
const SMARedirectLazy = React.lazy(() => import('../pages/SMARedirect.page'))

export const smaRoutes = [
  {
    path: '/profile/integrations/sma/callback',
    element: (
      <Suspense fallback={<div></div>}>
        <SMARedirectLazy />
      </Suspense>
    ),
  },
]
